import React, { useEffect, useState } from 'react';
import getPdfThumbnailUrl from 'src/utils/get-pdf-thumbnail-url';

interface ThumbnailProps {
  url?: string;
  page?: number;
  width?: number;
  height?: number;
  scale?: number;
  defaultImage?: string;
  className?: string;
  alt?: string;
  fetchThumbnail?: () => Promise<Blob>;
}

const Thumbnail: React.FC<ThumbnailProps> = (props) => {
  const {
    url,
    width,
    height,
    scale,
    page = 1,
    defaultImage,
    className,
    alt = 'File thumbnail preview',
    fetchThumbnail,
  } = props;
  const [thumbnailUrl, setThumbnailUrl] = useState(defaultImage);

  useEffect(() => {
    const setStateThumbnailUrl = async () => {
      if (fetchThumbnail) {
        const blob = await fetchThumbnail();

        if (blob instanceof Blob) {
          const _blobUrl = URL.createObjectURL(blob);
          setThumbnailUrl(_blobUrl);
        } else {
          setThumbnailUrl(defaultImage ?? '');
        }
        return;
      }

      let _scale = scale;
      if ([width, height, scale].filter((p) => p !== undefined).length === 0) {
        _scale = 1;
      }

      if (url) {
        setThumbnailUrl(
          getPdfThumbnailUrl(url, page, {
            width,
            height,
            scale: _scale ?? 1,
          })
        );
      } else {
        setThumbnailUrl(defaultImage ?? '');
      }
    };
    setStateThumbnailUrl();
  }, [width, height, scale, url, page, defaultImage, fetchThumbnail]);
  return <img src={thumbnailUrl} alt={alt} className={className} />;
};

export default Thumbnail;
